// extracted by mini-css-extract-plugin
module.exports = {"Embeddedreport":"ReportEmbedComponent_Embeddedreport__SZX-k"};